var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24493 0.951947L0.800985 6.50983C0.720272 6.61084 0.690536 6.74111 0.720272 6.86619L1.04171 8.22793L2.47614 8.21C2.61255 8.20858 2.73857 8.14769 2.82212 8.04385C4.34057 6.14402 7.23538 2.52184 7.31751 2.41564C7.39492 2.29009 7.42513 2.11261 7.38454 1.94175C7.343 1.76663 7.23397 1.61795 7.07679 1.52308C7.04328 1.49995 6.24794 0.882562 6.2234 0.86321C5.92415 0.62343 5.48754 0.664967 5.24493 0.951947ZM0.761477 8.93964C0.59769 8.93964 0.455144 8.8273 0.416912 8.66729L0.0303379 7.02896C-0.0494312 6.68959 0.0298659 6.33936 0.247461 6.06748L4.69377 0.506295C4.69565 0.504407 4.69707 0.502047 4.69896 0.500159C5.18654 -0.0827699 6.06825 -0.168675 6.66298 0.308524C6.68658 0.326932 7.47625 0.940541 7.47625 0.940541C7.76323 1.11141 7.98743 1.4168 8.07239 1.77835C8.15688 2.13613 8.09552 2.50524 7.89869 2.81724C7.88406 2.84037 7.87132 2.86019 3.37403 8.48652C3.15738 8.7565 2.83264 8.91368 2.48383 8.91793L0.766197 8.93964H0.761477Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.d386a6da6c181b8d21e99df2b278546b.svg";
export { ForwardRef as ReactComponent };